import * as client from "../../client";
import { useUserById, useUsers } from "./data";

export const useRerunningMessage = ({
  update,
}: {
  update: client.ReportBeingUpdated | undefined;
  showName?: boolean;
}) => {
  const users = useUsers();
  const runner = useUserById(update?.running_user_id);
  if (!update) {
    return undefined;
  }
  const actor =
    runner?.id == users.data?.current_user.id
      ? "You are"
      : `${runner?.full_name} is`;
  return `${actor} re-processing this report right now - you'll be able to make edits once that has finished.`;
};
